import { useParams } from "react-router-dom";
import { DeckType } from "src/api/flashcardDecks";
import FlashcardsSkeleton from "src/components/NewComponents/Skeletons/Flashcards";
import { useGetUserDeck } from "src/hooks/useFlashcards";

import { KnowDontKnowApp } from "./modes/KnowDontKnowApp";
import { SpacedRepetitionApp } from "./modes/SpacedRepetitionApp";
import { ViewApp } from "./modes/ViewApp";

export function FlashcardsApp() {
	const params = useParams<{ deckId: string }>();
	const { data: deck, isLoading, isFetching } = useGetUserDeck(params.deckId);

	if (isLoading || !deck || isFetching) {
		return <FlashcardsSkeleton className="" />;
	}

	if (deck.type === DeckType.View) {
		return <ViewApp deck={deck} />;
	}

	if (deck.type === DeckType.KnowDontKnow) {
		return <KnowDontKnowApp deck={deck} deckCode={params.deckId} />;
	}

	return <SpacedRepetitionApp deck={deck} deckCode={params.deckId} />;
}
